import { AgentChat } from "../../agent-chat/AgentChat";
import { WazToolbar } from "../toolbar/WazToolbar";
import "./WazChat.css";

type WazChatProps = {

}

export const WazChat = ({} : WazChatProps) => {
    return (
        <div className="wazawan-chat">
            <WazToolbar />
            <AgentChat />
        </div>
    )
}